import gql from "graphql-tag";

const projectMutations = {


    createProject: gql`
        mutation CreateProject($name: String, $number_internal: String, $number_client: String, $code: String, $subtitle: String, $parent_id: Int, $owner_id: Int, $accounting_id: Int, $status_id: Int, $client_note: DateTime, $deadline: DateTime, $reminder: DateTime, $first_grace_period: DateTime, $second_grace_period: DateTime, $defects_eliminated: DateTime, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $internal: Boolean, $change_note: String, $note_id: Int, $address: String, $order_sum: Int, $total_order_sum: Int, $note_content: String, $tags: String) {
            createProject(name: $name, number_internal: $number_internal, number_client: $number_client, code: $code, subtitle: $subtitle, parent_id: $parent_id, owner_id: $owner_id, accounting_id: $accounting_id, status_id: $status_id, client_note: $client_note, deadline: $deadline, reminder: $reminder, first_grace_period: $first_grace_period, second_grace_period: $second_grace_period, defects_eliminated: $defects_eliminated, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, internal: $internal, change_note: $change_note, note_id: $note_id, address: $address, order_sum: $order_sum, total_order_sum: $total_order_sum, note_content: $note_content, tags: $tags) {
                id,
                name,
                number_internal,
                number_client,
                code,
                subtitle,
                parent_id,
                owner_id,
                accounting_id,
                status_id,
                client_note,
                deadline,
                reminder,
                first_grace_period,
                second_grace_period,
                defects_eliminated,
                created_at,
                updated_at,
                deleted_at,
                internal,
                change_note,
                note_id,
                address,
                order_sum,
                total_order_sum,
                note_content,
                tags
            }
        }
    `,
    updateProject: gql`
        mutation UpdateProject($id: ID!, $name: String, $number_internal: String, $number_client: String, $code: String, $subtitle: String, $parent_id: Int, $owner_id: Int, $accounting_id: Int, $status_id: Int, $client_note: DateTime, $deadline: DateTime, $reminder: DateTime, $first_grace_period: DateTime, $second_grace_period: DateTime, $defects_eliminated: DateTime, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $internal: Boolean, $change_note: String, $note_id: Int, $address: String, $order_sum: Int, $total_order_sum: Int, $note_content: String, $tags: String) {
            updateProject(id: $id, name: $name, number_internal: $number_internal, number_client: $number_client, code: $code, subtitle: $subtitle, parent_id: $parent_id, owner_id: $owner_id, accounting_id: $accounting_id, status_id: $status_id, client_note: $client_note, deadline: $deadline, reminder: $reminder, first_grace_period: $first_grace_period, second_grace_period: $second_grace_period, defects_eliminated: $defects_eliminated, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, internal: $internal, change_note: $change_note, note_id: $note_id, address: $address, order_sum: $order_sum, total_order_sum: $total_order_sum, note_content: $note_content, tags: $tags) {
                id,
                name,
                number_internal,
                number_client,
                code,
                subtitle,
                parent_id,
                owner_id,
                accounting_id,
                status_id,
                client_note,
                deadline,
                reminder,
                first_grace_period,
                second_grace_period,
                defects_eliminated,
                created_at,
                updated_at,
                deleted_at,
                internal,
                change_note,
                note_id,
                address,
                order_sum,
                total_order_sum,
                note_content,
                tags
            }
        }
    `,
};

export default projectMutations;
